import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors, spacing, typography } from '../../../../themes/stena-recycling';
import { inputBorderStyle, inputFieldStyles } from '../../../helpers/inputHelpers';

export const InputWrapper = styled.div`
  position: relative;
  height: ${spacing.mediumHigh};
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  width: ${spacing.small};
  height: ${spacing.small};
  padding: 12px;
  left: 0;
  box-sizing: content-box;
`;

export const IconButtonWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  padding: ${spacing.xxsmall};
`;

export const StyledSearchfield = styled.input<{ error: boolean }>`
  ${({ error }) => inputBorderStyle(error)}
  ${({ error }) => inputFieldStyles(error)}
  text-overflow: ellipsis;
  height: ${spacing.mediumHigh};
  padding-left: ${spacing.mediumHigh};
  padding-right: ${spacing.mediumHigh};

  /* clears the 'X' from search input */
  &[type='search']::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  &[type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  &[type='search']::-webkit-search-decoration,
  &[type='search']::-webkit-search-cancel-button,
  &[type='search']::-webkit-search-results-button,
  &[type='search']::-webkit-search-results-decoration {
    display: none;
  }
`;

export const SearchfieldWrapper = styled.div<{ fullWidth?: boolean; $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ $compact }) =>
    $compact &&
    css`
      ${InputWrapper} {
        display: flex;
        align-items: center;
      }
      ${InputWrapper},
      ${StyledSearchfield} {
        height: 32px;
      }

      ${StyledSearchfield} {
        padding: 0 ${spacing.small} 0 28px;
        &,
        &:hover,
        &:focus {
          border-color: ${colors.monochrome.grey20};
        }
      }

      ${SearchIconWrapper} {
        width: 20px;
        height: 20px;
        padding: 4px 8px;
      }

      ${IconButtonWrapper} {
        top: 0;
        padding: 0;
        padding-right: 4px;
        display: flex;
        align-items: center;

        button {
          width: ${spacing.small};
          height: ${spacing.small};
          min-width: ${spacing.small};
          padding: ${spacing.tiny};
        }

        svg {
          width: 20px;
          height: 20px;
        }
      }
    `}
`;

export const SearchfieldError = styled.span`
  ${typography.body.medium}
  letter-spacing: 0.5px;
  color: ${colors.alerts.error};
`;
